import React from "react";
import { Dialog } from "@blueprintjs/core";
import { Icon } from "../../../atoms/Icon";
import styles from "./ThemeSettings.module.scss";
import security from "../../../assets/security.svg";

export default function ThemePreviewPage({
  brandLogo,
  backgroundOption,
  backgroundImage,
  bgColor,
  textColor,
  headingColor,
  isOpen,
  onDismiss
}) {
  return (
    <Dialog isOpen={isOpen} className={styles.dialog}>
      <Icon name="cross" onClick={onDismiss} className={styles.closePreview} />
      <div className={styles.previewBody}>
        <div
          className={styles.bgImage}
          style={
            backgroundOption == "image"
              ? { backgroundImage: `url(${backgroundImage})` }
              : { backgroundColor: bgColor }
          }
        ></div>
        <div className={styles.playerContainer}>
          <div className={styles.header}>
            <img className={styles.brandLogo} src={brandLogo} />
            <div className={styles.title}>
              <h5 style={{ color: headingColor }}>New Skincare regime</h5>
              <span style={{ color: headingColor }}>grace maven</span>
            </div>
          </div>
          <div className={styles.mockPlayer}>
            <div className={styles.playIcon}>
              <Icon name="play" />
            </div>
          </div>
        </div>
        <div className={styles.detailContainer}>
          <div className={styles.dummyImages}>
            <div className={styles.bigImage}></div>
            <div className={styles.smallImageRow}>
              <div className={styles.smallImage}></div>
              <div className={styles.smallImage}></div>
            </div>
          </div>
          <div className={styles.details}>
            <h3 style={{ color: headingColor }}>Your Heading Text</h3>
            <p style={{ color: textColor }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.
            </p>
            <p style={{ color: textColor }}>
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley
            </p>
          </div>
          <div className={styles.buySection}>
            <button>Buy now $99.00</button>
            <img src={security} />
          </div>
        </div>
      </div>
    </Dialog>
  );
}
